import { MoneyBox } from '@apply/components';
import { formatCurrencyOrUndefined } from '@apply/ui';
import { IBudgetLand } from '@apply/api/src/api/ApplyApi';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetLandField } from '../../../../../queries/useBudgetLandField';

interface CurbsProps {
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const Curbs: React.FC<CurbsProps> = ({ required = false, propertyGuid, isReview = false }) => {
    const [curbs, set_curbs] = useBudgetLandField<number>(
        propertyGuid,
        (b) => (b.values?.['Site Work']?.['Curbs'] as number) ?? 0,
        (b, v) => ({ ...b, values: { ...b.values, 'Site Work': { ...b.values?.['Site Work'], 'Curbs': v } } })
    );
    const label = 'Curbs';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={formatCurrencyOrUndefined(curbs)}
                />
            ) : (
                <MoneyBox
                    id={'curbs'}
                    allowNegative={false}
                    value={curbs}
                    onChange={(value) => set_curbs(value)}
                    required={required}
                    label={label}
                />
            )}
        </>
    );
};
